import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import * as moment from 'moment';
import { BehaviorSubject, Observable } from 'rxjs';
import { CommonService } from '../../Common/common.service';

@Injectable({
  providedIn: 'root'
})
export class SelectClientService implements Resolve<any>
{
  clients_list: any[];
  onClientsChanged: BehaviorSubject<any>;
  /**
   * Constructor
   *
   * @paeram {HttpClient} _httpClient
   */
  constructor(
    private _httpClient: HttpClient,
    private _commonService: CommonService
  ) {
    // Set the defaults
    this.onClientsChanged = new BehaviorSubject([]);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Resolver
   *
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    return new Promise<void>((resolve, reject) => {
      Promise.all([
        this.getClientsList(""),
      ]).then(
        ([files]) => {

          resolve();
        },
        reject
      );
    });
  }

  /**
   * Get contacts
   *
   * @returns {Promise<any>}
   */
  getClientsList(search_text:string): Promise<any> {
    var data = {
      client_access_id: this._commonService.client_access_id,
      search_text: search_text
    }
    return new Promise((resolve, reject) => {
      this._httpClient.post<any>('api/auth/getuserassignedclients', data, {
        headers: new HttpHeaders({
          "Content-Type": "application/json"
        })
      }).subscribe((response: any) => {
        this.clients_list = response;
        this.onClientsChanged.next(this.clients_list);
        resolve(this.clients_list);
      }, reject);
    });
  }

  /**
   * Delete note
   *
   * @param contact
   */
  UpdateClientUserInviteStatus<T>(data): Observable<T> {
    return this._httpClient.post<T>('/api/auth/updateclientuserinvitestatus', data, {
      headers: new HttpHeaders({
        "Content-Type": "application/json"
      })
    })
  }
}
